import {defineStore} from 'pinia';
import {ModuleDbOption} from './moduleConst';
import dbOptionAPI from '@/apis/di/dbOptionAPI';
import locationAPI from '@/apis/di/locationAPI';
import commonFunction from '@/commons/commonFunction';

const state = {};

const actions = {
  /**
   * Load dữ liệu dbOption
   * HQMINH 04.05.2023
   */
  async load() {
    const res = await dbOptionAPI.getDbOptions();
    this.state = res || {};

    return res;
  },

  /**
   * Lấy dữ liệu danh sách dữ liệu dbOption theo key
   * VDDONG 16/04/2024
   */
  async loadByKeys(payload) {
    const res = await dbOptionAPI.getDbOptionByKeys(payload);

    //HQMINH 03.05.2024: Lấy 1 key ra thì gán lại key đó vào state để có full Option
    if (res) {
      Object.assign(this.state, res);
    }

    return res;
  },

  /**
   * Cập nhập dbOption
   * HQMINH 04.05.2023
   */
  async update(payload, isUpdateDb = true) {
    let res = true;
    
    if(isUpdateDb) {
      res = await dbOptionAPI.updateDbOptions(payload || {});
    }

    if (res) {
      Object.assign(this.state, payload);
    }

    return res;
  },

  /**
   * Thêm mới dbOption, nếu có thì update
   * tvtoan - 02/01/2024
   */
  async insertUpdate(payload) {
    commonFunction.mask();
    const res = await dbOptionAPI.insertUpdateDbOptions(payload || {});
    if (res) {
      Object.assign(this.state, payload);
    }
    commonFunction.unmask();
    return res;
  },

  /**
   * Lấy danh sách các tỉnh
   * NVXUAN 02.06.2023
   */
  async getAllProvince() {
    const res = await locationAPI.getAllProvince();
    return res;
  },

  /**
   * Lấy danh sách các huyện
   * NVXUAN 02.06.2023
   */
  async getAllDistrict() {
    const res = await locationAPI.getAllDistrict();
    return res;
  },

  /**
   * Lấy danh sách các xã
   * NVXUAN 02.06.2023
   */
  async getAllCommunee() {
    const res = await locationAPI.getAllCommunee();
    return res;
  },

  /**
   * Lấy danh sách location theo parentID
   * @param {string} parentID LocationID cha
   * NVXUAN 02.06.2023
   */
  async getLocationByParentID(parentID) {
    const res = await locationAPI.getLocationByParentID(parentID);
    return res;
  },

  /**
   * Lấy danh sách dbotpion theo database id
   * @param {Guid} databaseId
   * TVTOAN 12.01.2024
   */
  async getDbOptionByDatabaseId(databaseId) {
    const res = await dbOptionAPI.getDbOptionByDatabaseId(databaseId);
    return res;
  },
};
const getters = {};

export const useDbOptionStore = defineStore(ModuleDbOption, {
  state: () => ({
    items: state,
    ...state,
    _config: {
      key: 'option_id',
      table: 'di_dboption',
      moduleName: 'dbOptions',
    },
    moduleName: 'dbOptions',
  }),
  actions: actions,
  getters: getters,
});
